export const IconArrowsVerticalDropdown20: {
  name: 'icon_arrows_vertical_dropdown_20-a1f441cc2a2e'
} = {
  name: 'icon_arrows_vertical_dropdown_20-a1f441cc2a2e'
}
